module.exports = __webpack_public_path__ + "static/media/lascalles01_small@2x.5c57de93.jpg";